import React from 'react'
import styled from 'styled-components'
import { ChevronRightIcon, useMatchBreakpoints } from 'toonswap-uikit'
import { useTranslation } from 'contexts/Localization'

interface DetailsProps {
  actionPanelToggled: boolean
}

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-right: 8px;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 14px;
`

const StyledChevronRightIcon = styled(ChevronRightIcon)<{ toggled: boolean }>`
  transform: ${({ toggled }) => (toggled ? 'rotate(90deg)' : 'rotate(0)')};
  height: 20px;
`

const Details: React.FC<DetailsProps> = ({ actionPanelToggled }) => {
  const { isXl } = useMatchBreakpoints()
  const isMobile = !isXl
  const { t } = useTranslation()

  return (
    <Container>
      {!isMobile && t('Details')}
      <StyledChevronRightIcon color="#ffffff" toggled={actionPanelToggled} />
    </Container>
  )
}

export default Details
